// src/components/HeroSection.js
import React, { useEffect, useRef, useState } from "react";
import "animate.css";

import img from "../../assets/img/expect-invis.png";

const HeroSection = ({ scrollToConsult }) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          } else {
            setIsVisible(false); // Set to false when the section is not visible
          }
        });
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="container-fluid">
      <div className="row align-items-center" ref={sectionRef}>
        <div className="col-lg-6 px-lg-5 mb-3 text-center text-lg-start">
          <h2
            className={`text-dark fs-40 fw-800 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}>
            What to expect at your{" "}
            <span className="text-golden">free consultation?</span>
          </h2>
          <p
            className={`fs-18 mt-3 mb-3 fw-400 text-dark ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}>
            At your consultation you will meet our friendly treatment
            co-ordinator and your treating dentist to have your photos and scan
            taken. The team will then show you how your smile can be improved
            and answer any questions you have.
          </p>
          <ul
            className={`list-unstyled ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}>
            <li>
              {" "}
              <p className="fs-18 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>A{" "}
                <span className="text-golden">3D smile</span> simulation scan
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-18 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>All your questions{" "}
                <span className="text-golden">answered</span>
              </p>{" "}
            </li>
            <li>
              {" "}
              <p className="fs-18 fw-700">
                <i class="fa fa-check-circle-o me-2"></i>An outline of{" "}
                <span className="text-golden">all costs </span>
                and offer details
              </p>{" "}
            </li>
          </ul>
          <div
            className="d-flex justify-content-center justify-content-lg-start"
            onClick={scrollToConsult}>
            <a
              className={`btn btn-golden fs-14 ${
                isVisible
                  ? "animate__animated animate__zoomIn"
                  : "animate__animated animate__fadeOut"
              }`}>
              BOOK A FREE CONSULTATION
            </a>
          </div>
        </div>
        <div className="col-lg-6">
          <img
            src={img}
            className={` img-fluid ps-0 ps-lg-5 ${
              isVisible
                ? "animate__animated animate__zoomIn"
                : "animate__animated animate__fadeOut"
            }`}
            alt="office-expectation"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
